module.exports = __webpack_public_path__ + "img/img_map_route.b9084a4f.png";